// src/components/pages/ViewAllChallengesPage.js

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Box, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "styled-components";
import {
  fetchUserChallenges,
  fetchUserProfileFromFirestore,
} from "../../services/profileService";
import { fetchHomePageChallenges } from "../../services/challengeService";
import ViewAllChallengesSection from "../organisms/ViewAllChallengesSection";

const ViewAllChallengesPage = () => {
  const { profileId } = useParams(); // Use profileId from the URL
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [headerText, setHeaderText] = useState("All Challenges");
  const [challenges, setChallenges] = useState([]);

  useEffect(() => {
    const fetchChallenges = async () => {
      setLoading(true);
      try {
        // Get the current user profile from localStorage
        const userProfile = localStorage.getItem("userProfile");
        const parsedProfile = userProfile ? JSON.parse(userProfile) : null;

        let fetchedChallenges;
        let header;

        if (profileId && parsedProfile && profileId === parsedProfile.uid) {
          // If the user is viewing their own profile, fetch all challenges including drafts
          fetchedChallenges = await fetchUserChallenges(
            profileId,
            parsedProfile?.uid
          );
          header = "My Challenges";
        } else if (profileId) {
          // If viewing someone else's profile, fetch the user's profile data and only published challenges
          const userProfileData = await fetchUserProfileFromFirestore(
            profileId
          );
          fetchedChallenges = await fetchUserChallenges(
            profileId,
            parsedProfile
          );
          const displayName = userProfileData?.displayName || "User";
          const firstName = displayName.split(" ")[0]; // Extract the first name
          header = firstName && firstName.trim()
            ? `${firstName}'s Challenges`
            : "Challenges";

        } else {
          // If no profileId is provided, fetch all published challenges
          fetchedChallenges = await fetchHomePageChallenges();
          header = "All Challenges";
        }

        setHeaderText(header);
        setChallenges(fetchedChallenges);
      } catch (err) {
        setError("Error fetching challenges data.");
      } finally {
        setLoading(false);
      }
    };

    fetchChallenges();
  }, [profileId]);

  if (loading) {
    return (
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60vh",
          }}
        >
          <CircularProgress
            sx={{
              color: theme.colors.red,
            }}
          />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" color="error">
            {error}
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      <Box>
        <ViewAllChallengesSection
          header={headerText}
          challenges={challenges}
          theme={theme}
        />
      </Box>
    </Container>
  );
};

export default ViewAllChallengesPage;
